import rill from "rill";
import Billing from "./billing";
import Competition from "./competition";
import Cycle from "./cycle";
import Exercise from "./exercise";
import Issue from "./issue";
import Notification from "./notification";
import User from "./user";
import CustomMetrics from "./custom-metrics";
import RepMaximum from "./rep-maximum";
import Nutrition from "./nutrition";
import Widgets from "./widgets";
import Recipes from "./recipes";
import Stores from "./stores";
import Links from "./links";
import FileDocument from "./file-document";
import VideoPlaylist from "./video-playlist";
import MacroCalculator from "./macro-calculator";
import ExerciseCatalog from "./exercise-catalog";
import Admin from "./admin";
import Questionnaire from "./questionnaire";
import AnnualPlanner from "./annual-planner";
import PlanManager from "./plan-manager";
import DailyAccountability from "./daily-accountability";
import Guides from "./guides";
import Theme from "./theme";
import Organizations from "./organizations";
import Chat from "./chat";
import CoachVideos from "./coach-videos";
import CustomWorkflows from "./custom-workflows";
import CommunityChat from "./community-chat";
import MealPlanLibrary from "./meal-plan-library";
import ActivityFeed from "./activity-feed";
import WidgetDailyAccountability from "./widget-daily-accountability";
import GettingStarted from "./getting-started";
import ClientGoals from "./client-goals";
import MealPlanner from "./meal-planner";
import Common from "./common";

const Actions = (app) => {
  app.at(
    "/actions/*",
    rill()
      .get("/refresh", ({ req, res }) => {
        /**
         * This will go back to the previous url (the referrer, defaulting to the dashboard).exercise
         * It updates the query string with the current request query using '@rill/refresh-with'.
         * https://github.com/rill-js/refresh-with
         *
         * "#_" is also appended onto the end of the url to prevent the browser automatically scrolling to the top.
         */
        res.refreshWith(req.query, {
          url: (req.get("Referrer") || "/dashboard").replace(/#.*$/, "") + "#_",
        });
      })
      .setup(Billing)
      .setup(Competition)
      .setup(Cycle)
      .setup(Exercise)
      .setup(Issue)
      .setup(Notification)
      .setup(User)
      .setup(CustomMetrics)
      .setup(RepMaximum)
      .setup(Nutrition)
      .setup(Widgets)
      .setup(Recipes)
      .setup(Stores)
      .setup(Links)
      .setup(FileDocument)
      .setup(VideoPlaylist)
      .setup(MacroCalculator)
      .setup(ExerciseCatalog)
      .setup(Admin)
      .setup(Questionnaire)
      .setup(AnnualPlanner)
      .setup(PlanManager)
      .setup(DailyAccountability)
      .setup(Guides)
      .setup(Theme)
      .setup(Organizations)
      .setup(Chat)
      .setup(CoachVideos)
      .setup(ActivityFeed)
      .setup(CustomWorkflows)
      .setup(CommunityChat)
      .setup(GettingStarted)
      .setup(MealPlanLibrary)
      .setup(ActivityFeed)
      .setup(WidgetDailyAccountability)
      .setup(ClientGoals)
      .setup(MealPlanner)
      .setup(Common)
  );
};

export default Actions;
